import { Container, Row } from '@slal/ui/layout';
import { StyledCol, StyledFeatureBannerWrapper } from './styles';
import { StyledHeading } from '../Layout';
import { FeatureBannerProps } from './types';
import { DefaqtoBanner } from './DefaqtoBanner';

export const FeatureBanner = ({ defactoBanner, featureBannerImgSrc, id, title }: FeatureBannerProps) => {
    return (
        <>
            <StyledFeatureBannerWrapper role="banner" featureBannerImgSrc={featureBannerImgSrc}>
                <Container>
                    <Row>
                        <StyledCol col={9} md={8} xl={6}>
                            <StyledHeading id={id} level={1}>
                                {title}
                            </StyledHeading>
                        </StyledCol>
                    </Row>
                </Container>
            </StyledFeatureBannerWrapper>
            {defactoBanner && <DefaqtoBanner />}
        </>
    );
};
